import { Label, mergeStyles, Stack, Text } from '@fluentui/react';

import taxAdmins from '../../../shared/tax-admins.json';
import { BorderedStack, Item } from './utils';

type AccountVariables = { [key: string]: any };
type Props = { accountVariables: AccountVariables };

export default ({ accountVariables }: Props) => {
  const map = (item: typeof items[0][0]) => {
    const value = item.getValue(accountVariables);
    if (!value) return;

    return (
      <Stack horizontal className="form-styles">
        <Label className={labelStyles}>
          <span style={item.labelHidden ? { color: "#fff" } : undefined}>
            {item.label}
          </span>
          &nbsp;:&nbsp;
        </Label>
        <Text>{value}</Text>
      </Stack>
    );
  };

  return (
    <BorderedStack grow horizontal>
      {[0, 1].map((index) => (
        <Item grow width="50%" style={{ padding: "2px 6px" }}>
          <Stack tokens={{ childrenGap: 5 }}>
            {items[index].map(map).filter((v) => v)}
          </Stack>
        </Item>
      ))}
    </BorderedStack>
  );
};

const labelStyles = mergeStyles({
  width: "32%",
  whiteSpace: "nowrap",
  padding: "0",
  margin: "0",
});
const items = [
  [
    {
      key: "name",
      label: "Şirket Ünvanı",
      getValue: ({ companyName }: AccountVariables) => companyName,
    },
    {
      key: "name",
      label: "Adı Soyadı",
      getValue: ({ name }: AccountVariables) => name || "-",
    },
    {
      key: "phone0",
      label: "Telefon",
      getValue: ({ phones }: AccountVariables) =>
        phones?.[0]?.replace("+90 ", ""),
    },
    {
      key: "phone1",
      label: "Telefon",
      labelHidden: true,
      getValue: ({ phones }: AccountVariables) =>
        phones?.[1]?.replace("+90 ", ""),
    },
    {
      key: "invoiceAddress",
      label: "Fatura Adresi",
      getValue: ({ shipmentAddress, invoiceAddress }: AccountVariables) =>
        shipmentAddress === invoiceAddress
          ? "" // "Teslim adresi ile aynı"
          : invoiceAddress,
    },
  ],
  [
    {
      key: "email",
      label: "E-Posta",
      getValue: ({ email }: AccountVariables) => email,
    },
    {
      key: "vkn",
      label: "VKN / VD",
      getValue: ({ citizenId, taxAdminId }: AccountVariables) =>
        [citizenId, taxAdmins.find((t) => t.id === taxAdminId)?.name]
          .filter(Boolean)
          .join(" / "),
    },
    {
      key: "shipmentAddress",
      label: "Teslim Adresi",
      getValue: ({ shipmentAddress }: AccountVariables) => shipmentAddress,
    },
  ],
];
